import axios from 'axios';

//const dataFileNameBase = "../data/percentiles/gw_percentiles_";

// area ranges and colors
const areas = {
    default: [
        ['low','10','#8b1a1a','<10th percentile'],
        ['10','25','#ee9a00',null],
        ['25','75','#05ed00',null], 
        ['75','90','#63b8ff',null], 
        ['90','high','blue','>90th percentile'],
    ],
    usdm: [
        ['30','high','green','None'],
        ['20','30','#ffff00','D0'],
        ['10','20','#fbd37f','D1'],
        ['5','10','#ee9a00','D2'],
        ['2','5','#e60001','D3'],
        ['low','2','#730000','D4'],
    ]
};

// remember January is month 0
const oneday = 1000 * 60 * 60 * 24;  // in milliseconds
const today = new Date();
const today_month = today.getMonth();
const grfsmonth = today_month != 11 ? today_month + 1 : 0;		  // Graph starting month
const grfsdate = new Date(2021, grfsmonth, 1)	;						    // standardized to 2021
const sdoy = Math.ceil((grfsdate - new Date(grfsdate.getFullYear(), 0, 0, 0)) / oneday);
const sindex = sdoy - 1;   // index of starting date in percentile arrays

// add area ranges to graph
const fill_graph_areas = (pcts, area_selection, datelist, chart) => {
    areas[area_selection].forEach(([r1,r2,color,altlabel],k) => {
        //datelist starts with first day on graph; pvals starts Jan 1
        const items = [];
        const pvals1 = pcts[r1];
        const pvals2 = pcts[r2];
        for (let x = sindex; x < 365; x++) {
            items.push([datelist[x-sindex].getTime(), pvals1[x], pvals2[x]]);
        }
        for (let x = 0; x < sindex; x++) {
            items.push([datelist[x+365-sindex].getTime(), pvals1[x], pvals2[x]]);
        }
        const newSeries = {
            name: altlabel ? altlabel : (r1 + '-' + r2 + 'th percentile'),
                data: items,
                color: color,
                fill_color: color,
                fill_opacity: 0.50,
                type: 'arearange',
                zIndex: 1,
                legendIndex: k+4
        };
        chart.addSeries(newSeries);
    });
};

// add a line to graph
const fill_graph_line = (pcts, datelist, chart, name, color, dashstyle, linewidth, legendindex) => {
    //datelist starts with first day on graph; pvals starts Jan 1
    const items = [];
    const pvals = pcts[name.toLowerCase()];
    for (let x = sindex; x < 365; x++) {
        items.push([datelist[x-sindex].getTime(), pvals[x]]);
    }
    for (let x = 0; x < sindex; x++) {
        items.push([datelist[x+365-sindex].getTime(), pvals[x]]);
    }
    const newSeries = {
        name: name != '50' ? name : 'Median',
        data: items,
        color: color,
        lineWidth: linewidth,
        dashStyle: dashstyle,
        marker: {
        enabled: false
        },
        zIndex: 2,
        legendIndex: legendindex,
    };
    chart.addSeries(newSeries)
};

const add_stnName_subtitle = (name, chart) => {
    if (name) {
        chart.subtitle.textStr = name;
        chart.redraw();
    }
};

const fetchData = (dataFileNameBase, stnid, area_selection, datelist, chart) => {
    const dataFileName = dataFileNameBase + stnid + ".json";
    axios.get(dataFileName)
        .then(results => {
            if (results.data.pcts) {
                if (area_selection === 'default') {
                    fill_graph_line(results.data.pcts, datelist, chart, "Low", "red", "solid", 3, 3);
                };
                if (results.data.pcts.hasOwnProperty("10")) {
                    fill_graph_areas(results.data.pcts, area_selection, datelist, chart);
                }
                if (area_selection === 'default') {
                    fill_graph_line(results.data.pcts, datelist, chart, "High", "darkblue", "solid", 3, 9);
                };
               fill_graph_line(results.data.pcts, datelist, chart, "50", "black", "Dot", 1, 10);
               add_stnName_subtitle(results.data.name, chart);
            }
        })
        .catch(err => {
            const newSeries = {
                name: 'Percentiles unavailable',
                data: [],
                legendIndex: 3,
                lineWidth: 0,
                marker: {
                    enabled: false
                },
            };
            chart.addSeries(newSeries);
            console.log(err.message);
        });
};

export const fill_graph_pcts = (dataFileNameBase, stnid, area_selection, datelist, chart) => {
    fetchData(dataFileNameBase, stnid, area_selection, datelist, chart);
}